import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button,
  Label,
  Grid
} from "semantic-ui-react";
import CustomSearch from "../../shared/CustomSearch";
import { escuelasOps, escuelasSelectores } from "../../../ducks/escuelas";
import { busquedasOps } from "../../../ducks/busquedas";
import TablaColegiosEscuelas from "./colegios/TablaColegiosEscuelas";
import ModalAsignacion from "./colegios/ModalAsignacion";
import { isEmpty } from "lodash";

class Colegios extends React.Component {
  state = { idColegio: null, openModal: false, visible: false };

  componentDidMount() {
    this.props.fetchSearchDataColegios();
    this.props.obtenerListaColegiosConEscuelas();
    this.setState({ visible: true });
  }

  componentWillUnmount() {
    this.props.detachEscuelasListeners();
    this.props.limpiarListaColegioEscuelas();
    this.props.resetSearchData();
    this.props.detachSearchData();
  }

  handleSelectColegio = idColegio => this.setState({ idColegio });

  handleButtonClick = () => this.setState({ openModal: true });

  handleAcceptModal = values => {
    const { idColegio } = this.state;
    if (!isEmpty(idColegio) && idColegio !== "reset") {
      this.props.asignarColegioAEscuela({
        idColegio: this.state.idColegio,
        values
      });
      this.setState({ idColegio: "reset", openModal: false });
    }
  };

  handleCancelModal = () =>
    this.setState({ openModal: false, idColegio: "reset" });

  handleBorrarLinea = ({ key }) =>
    this.props.eliminarColegioListaEscuelas({ idColegio: key });

  handleRowClick = (a, b, c) => console.log(a, b, c);

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={150}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header inverted as="h2">
                Listado de Colegios con Escuelas
              </Header>
            </Segment>
            <Segment>
              <Grid columns={3}>
                <Grid.Column>
                  <Label content="Búsqueda de Colegios" basic size="big" />
                </Grid.Column>
                <Grid.Column>
                  <CustomSearch
                    fluid
                    iconPosition="left"
                    id="buscarColegio"
                    name="busqueda"
                    type="text"
                    datosBusqueda={this.props.searchDataColegios}
                    onSelect={this.handleSelectColegio}
                    value={this.state.idColegio}
                    icon="search"
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    color="pink"
                    content="Añadir colegio"
                    onClick={this.handleButtonClick}
                    disabled={
                      isEmpty(this.state.idColegio) ||
                      this.state.idColegio === "reset"
                    }
                  />
                </Grid.Column>
              </Grid>
            </Segment>

            <Transition.Group animation="scale" duration={250}>
              {!isEmpty(this.props.listaColegiosEscuelas) && (
                <Segment basic textAlign="center">
                  <Segment>
                    <Header as="h3">Colegios con Escuelas de Primavera</Header>
                    <TablaColegiosEscuelas
                      datos={this.props.listaColegiosEscuelas}
                      handleBorrarLinea={this.handleBorrarLinea}
                      handleRowClick={this.handleRowClick}
                    />
                  </Segment>
                </Segment>
              )}
            </Transition.Group>

            <ModalAsignacion
              open={this.state.openModal}
              handleCancelModal={this.handleCancelModal}
              handleAcceptModal={this.handleAcceptModal}
            />
          </Container>
        )}
      </Transition.Group>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  searchDataColegios: escuelasSelectores.getColegiosDisponibles(state),
  listaColegiosEscuelas: state.escuelas.listaColegiosEscuelas
});

const mapDispatchToProps = {
  /*- busquedasOps -*/
  fetchSearchDataColegios: busquedasOps.fetchSearchDataColegios,
  detachSearchData: busquedasOps.detachSearchData,
  resetSearchData: busquedasOps.resetSearchData,
  /*- escuelasOps -*/
  asignarColegioAEscuela: escuelasOps.asignarColegioAEscuela,
  obtenerListaColegiosConEscuelas: escuelasOps.obtenerListaColegiosConEscuelas,
  detachEscuelasListeners: escuelasOps.detachEscuelasListeners,
  limpiarListaColegioEscuelas: escuelasOps.limpiarListaColegioEscuelas,
  eliminarColegioListaEscuelas: escuelasOps.eliminarColegioListaEscuelas
};

export default connect(mapStateToProps, mapDispatchToProps)(Colegios);



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/Colegios.jsx